export default __webpack_public_path__ + "static/media/ic-check.0d50f390.svg";